import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate, useLocation } from'react-router-dom';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../Firebase'
import { toast } from 'react-toastify'
import { useAuth } from './AuthContext'

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="/">
        Music Gofer Ltd
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SignIn() {

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [loading, setLoading] = useState(false)

    let navigate = useNavigate();
    let location = useLocation();
    const { currentUser, isLoading } = useAuth();

    // Redirect if already logged in
    useEffect(() => {
        if (!isLoading && currentUser) {
            // Get the intended destination from location state, or default to '/'
            const from = location.state?.from?.pathname || '/';
            navigate(from, { replace: true });
        }
    }, [currentUser, isLoading, navigate, location]);

    const handleSubmit = (event) => {
        event.preventDefault();

        if(!email || !password){
          toast.error("Please input email and password")
        } else {
          setLoading(true);
          signInWithEmailAndPassword(auth, email, password)
          .then((userCredential) => {
              // Don't navigate here - let the useEffect handle it once currentUser is set
              // This ensures AuthContext has time to update the auth state
          })
          .catch((error) => {
              setLoading(false);
              const errorCode = error.code;
              const errorMessage = error.message;
              toast.error(errorMessage)
          });
        }
    };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: '#395076' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField margin="normal" fullWidth id="email" label="Email Address" name="email" autoComplete="email" autoFocus value={email} onChange={(e)=>setEmail(e.target.value)}/>
            <TextField margin="normal" fullWidth name="password" label="Password" type="password" id="password" autoComplete="current-password" value={password} onChange={(e=>setPassword(e.target.value))}
            />
          
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading || isLoading}
              sx={{ backgroundColor: '#395076', mt: 3, mb: 2 }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="/reset-password" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
            
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}